import { IUserDetail } from '../../../types/user'
import { AuthActions } from '../actions/authActions'
import * as constants from '../actions/constants'

// Check if user exists in localStorage on initialization
const getInitialUser = (): IUserDetail | null => {
  const storedUser = localStorage.getItem('user')
  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser)
      return parsedUser
    } catch (error) {
      console.error('[user reducer] Failed to parse user from localStorage:', error)
      localStorage.removeItem('user')
      localStorage.removeItem('logged-in')
    }
  }
  
  return {
    username: '',
    email: '',
    permissions: [],
    id: '',
    first_name: '',
    last_name: '',
    is_staff: false,
    is_active: false,
    is_superuser: false
  }
}

export const user = (state: IUserDetail | null = getInitialUser(), action: AuthActions): IUserDetail | null => {
  switch(action.type) {
    case constants.LOGIN_SUCCESS:
      localStorage.setItem('logged-in', 'success')
      localStorage.setItem('user', JSON.stringify(action.user))
      return action.user

    case constants.GET_LOGGED_IN_USER_SUCCESS: {
      const hasId = Object.prototype.hasOwnProperty.call(action.user, 'id')
      const hasUsername = Object.prototype.hasOwnProperty.call(action.user, 'username')
      const hasEmail = Object.prototype.hasOwnProperty.call(action.user, 'email')
      if (hasId && hasUsername && hasEmail) {
        localStorage.setItem('logged-in', 'success')
        localStorage.setItem('user', JSON.stringify(action.user))
        return action.user
      }
      localStorage.clear()
      return null
    }

    case constants.LOGIN_HAS_ERRORED:
      localStorage.clear()
      return null;

    case constants.LOGOUT_SUCCESS:
      localStorage.clear()
      return null;

    default:
      return state;
  }
}
